(async function () {
  /**
   * Wait for network to be idle or user interaction.
   */
  async function idle() {
    return new Promise((resolve) => {
      const interactionEvents = ['keydown', 'mousemove', 'touchmove', 'touchstart', 'touchend', 'wheel'];
      const handleInteraction = () => {
        interactionEvents.forEach((event) => window.removeEventListener(event, handleInteraction));
        resolve();
      };

      interactionEvents.forEach((event) => window.addEventListener(event, handleInteraction));
    });
  }

  /**
   * Observe visibility of an element using IntersectionObserver.
   * @param {HTMLElement} element - Element to observe.
   */
  async function visible(element) {
    return new Promise((resolve) => {
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            observer.disconnect();
            resolve(true);
            break;
          }
        }
      });
      observer.observe(element);
    });
  }

  /**
   * Activate idle scripts.
   */
  async function activateIdleScripts() {
    const idleScripts = document.querySelectorAll('[data-loading="idle"]');
    if (idleScripts.length > 0) {
      await idle();
      idleScripts.forEach((script) => {
        const newScript = document.createElement('script');
        newScript.type = 'text/javascript';
        newScript.src = script.src;

        Array.from(script.attributes)
          .filter(attr => attr.name !== 'src' && attr.name !== 'type' && attr.name !== 'data-loading')
          .forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });

        script.parentNode.insertBefore(newScript, script);
        script.remove();
      });
    }
  }

  /**
   * Activate visible scripts when their section enters the viewport.
   */
  function activateVisibleScripts() {
    const sections = document.querySelectorAll('.shopify-section');
    sections.forEach((section) => {
      const visibleScripts = section.querySelectorAll('[data-loading="visible"]');
      if (visibleScripts.length > 0) {
        visible(section).then(() => {
          visibleScripts.forEach((script) => {
            const newScript = document.createElement('script');
            newScript.type = 'text/javascript';
            newScript.src = script.src;

            Array.from(script.attributes)
              .filter(attr => attr.name !== 'src' && attr.name !== 'type' && attr.name !== 'data-loading')
              .forEach(attr => {
                newScript.setAttribute(attr.name, attr.value);
              });

            script.parentNode.insertBefore(newScript, script);
            script.remove();
          });
        });
      }
    });
  }

  activateIdleScripts();
  activateVisibleScripts();
})();
